import React from 'react'

export default function Cart({ className }) {
  return (
    <svg viewBox="0 0 26 24" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M25.787 5.792l-2.625 8.23a.987.987 0 01-.948.721H8.781a.987.987 0 01-.947-.715L4.336 2.971H1.833a.99.99 0 01-.987-.995.99.99 0 01.987-.995h3.242c.438 0 .824.291.947.715L9.52 12.753h11.95l.851-1.997H11.143a.99.99 0 01-.986-.995.99.99 0 01.986-.995h11.745l.641-2.253H10.115a.99.99 0 01-.986-.995.99.99 0 01.986-.995h14.724c.31 0 .601.147.788.396.186.25.245.573.16.873zM8.824 16.429h14.547a.99.99 0 01.987.995.99.99 0 01-.987.995H8.824a.99.99 0 01-.987-.995.99.99 0 01.987-.995zm13.643 4.776c0 1.536-1.239 2.786-2.762 2.786-1.524 0-2.763-1.25-2.763-2.786s1.239-2.786 2.763-2.786c1.523 0 2.762 1.25 2.762 2.786zm-2.762-.796a.793.793 0 00-.789.796c0 .439.353.796.789.796a.793.793 0 00.789-.796.793.793 0 00-.789-.796zm-5.708.796c0 1.536-1.24 2.786-2.763 2.786-1.522 0-2.762-1.25-2.762-2.786s1.24-2.786 2.762-2.786c1.523 0 2.763 1.25 2.763 2.786zm-2.763-.796a.793.793 0 00-.788.796c0 .439.353.796.788.796a.793.793 0 00.789-.796.793.793 0 00-.789-.796z"
      />
    </svg>
  )
}
